import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, isRef as _isRef } from "vue"
import _imports_0 from '@/assets/c4.png'


const _hoisted_1 = { class: "box" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "c4",
  src: _imports_0,
  alt: "c4"
}, null, -1)
const _hoisted_3 = { class: "screen" }
const _hoisted_4 = { class: "btns" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "music" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "menu" }
const _hoisted_12 = { class: "info" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "说明"),
  /*#__PURE__*/_createElementVNode("p", null, "按下「*」即可启动 C4；"),
  /*#__PURE__*/_createElementVNode("p", null, " 拆包需要输入对应密码，然后按下「#」即可确定密码进行拆除，输入过程无法看见增加难度，如果输入错误可按「*」进行删除上一位； "),
  /*#__PURE__*/_createElementVNode("p", null, "进入设置可修改 C4 爆炸时间以及密码；")
], -1)
const _hoisted_14 = { class: "setting" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h1", null, "炸弹爆炸时间（秒）", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h1", null, "拆包密码", -1)

import { ref } from "vue";
import FastClick from "fastclick";

// 展示模块

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const showIndex = ref(0);
function show(i: number) {
    showIndex.value = i;
}

// 解决移动端点击延迟
FastClick.attach(document.body);

// 屏幕显示文字
const screenText = ref("");

// 按键声
const anjianDom = ref<any>(null);
const anjianMp3 = new URL(
    "@/assets/music/按键.mp3",
    import.meta.url
).toString();

// 按键映射
const keyMap = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "*", "0", "#"];

/**
 * 按键
 * @param i 按键索引
 */
function btnClick(i: number) {
    const text = keyMap[i];
    // 如果按 * 则开始下包
    if (text == "*" && !bombState) {
        return bombInstall();
    }
    if (bombState) {
        bombClick(text);
    } else {
        screenText.value += text;
    }
    // 播放
    playAudio(anjianDom.value);
}

/**
 * 播放音频
 * @param audio 音频 dom
 */
function playAudio(audio: any) {
    if (audio.currentTime > 0) {
        audio?.pause();
        audio.currentTime = 0;
    }
    audio?.play();
}

// 下包音效
const bombInstallDom = ref<any>(null);
const bombInstallMp3 = new URL(
    "@/assets/music/完整下包.mp3",
    import.meta.url
).toString();

/**
 * 下包
 */
function bombInstall() {
    screenText.value = "";
    playAudio(bombInstallDom.value);
    creenCb("7355608", 350, () => {
        setTimeout(() => {
            screenText.value = "炸弹已安放";
            bombState = true;
            bombing();
        }, 500);
    });
}

/**
 * 循环显示文字
 * @param str 文字内容
 * @param delay 延迟时间
 * @param cb 完成回调
 */
function creenCb(str: string, delay: number, cb: any) {
    if (str.length == 0) {
        return cb();
    }
    screenText.value += str[0];
    str = str.substring(1);
    setTimeout(() => {
        creenCb(str, delay, cb);
    }, delay);
}

// 滴滴声
const bombingDom = ref<any>(null);
const bombingMp3 = new URL(
    "@/assets/music/滴滴.mp3",
    import.meta.url
).toString();
// 爆炸声
const boomDom = ref<any>(null);
const boomMp3 = new URL("@/assets/music/爆炸.mp3", import.meta.url).toString();

// 爆炸时间
const boomSecond = ref(30);
// 爆炸倒计时
let cacheTime = 0;
// 滴滴声不同阶段延时
let delayTime = [1500, 1000, 500, 200];
// 当前滴滴延时
let nowDelayTime = 0;
// 秒计时器
let secondInterval: any = null;
// 滴滴计时器
let playInterval: any = null;
// 炸弹状态
let bombState = false;

/**
 * 包的滴滴
 */
function bombing() {
    // 求爆炸时间与阶段的平均值
    let cache = boomSecond.value / delayTime.length;

    // 计算每个阶段时间
    let cacheArr: Array<number> = [];
    for (let i = 1; i <= delayTime.length; i++) {
        cacheArr.push(cache * i);
    }

    // 触发第一阶段
    nowDelayTime = delayTime[0];
    console.log(`C4 进入第1阶段，delay：${nowDelayTime}`);
    bombPlay();

    // 秒计时
    secondInterval = setInterval(() => {
        cacheTime++;
        screenText.value = `爆炸倒计时：${boomSecond.value - cacheTime}秒`;
        // 包爆炸
        if (cacheTime >= boomSecond.value) {
            clearBomb();
            setTimeout(() => {
                screenText.value = `炸弹已经引爆`;
                bombState = false;
            }, 2000);
            return playAudio(boomDom.value);
        }

        // 阶段计算
        for (let i = 0; i < cacheArr.length; i++) {
            if (cacheTime == Number(cacheArr[i].toFixed(0))) {
                nowDelayTime = delayTime[i + 1];
                console.log(`C4 进入第${i + 2}阶段，delay：${nowDelayTime}`);
                return bombPlay();
            }
        }
    }, 1000);
}

/**
 * 滴滴音效循环，根据阶段延时
 */
function bombPlay() {
    clearInterval(playInterval);
    playInterval = setInterval(() => {
        playAudio(bombingDom.value);
    }, nowDelayTime);
}

/**
 * 下包后按键
 * @param text 内容
 */
let bombText = "";
let password = ref("1234567890");
function bombClick(text: string) {
    if (text == "*") {
        bombText = bombText.substring(1);
    } else if (text == "#") {
        if (bombText == password.value) {
            clearBomb();
            screenText.value = `炸弹已被拆除`;
        }
    } else {
        bombText += text;
    }
    console.log(`当前输入内容：${bombText}`);
}

/**
 * 拆除炸弹
 */
function clearBomb() {
    screenText.value = "";
    clearInterval(secondInterval);
    clearInterval(playInterval);
    cacheTime = 0;
    nowDelayTime = 0;
    bombState = false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, _toDisplayString(screenText.value), 1),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (item, index) => {
          return _createElementVNode("div", {
            key: index,
            onClick: ($event: any) => (btnClick(index))
          }, null, 8, _hoisted_5)
        }), 64))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("audio", {
          src: _unref(anjianMp3),
          controls: "",
          hidden: "",
          ref_key: "anjianDom",
          ref: anjianDom
        }, null, 8, _hoisted_7),
        _createElementVNode("audio", {
          src: _unref(bombInstallMp3),
          controls: "",
          hidden: "",
          ref_key: "bombInstallDom",
          ref: bombInstallDom
        }, null, 8, _hoisted_8),
        _createElementVNode("audio", {
          src: _unref(bombingMp3),
          controls: "",
          hidden: "",
          ref_key: "bombingDom",
          ref: bombingDom
        }, null, 8, _hoisted_9),
        _createElementVNode("audio", {
          src: _unref(boomMp3),
          controls: "",
          hidden: "",
          ref_key: "boomDom",
          ref: boomDom
        }, null, 8, _hoisted_10)
      ])
    ], 512), [
      [_vShow, showIndex.value == 0]
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (show(1)))
      }, "说明"),
      _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (show(2)))
      }, "设置"),
      _createElementVNode("div", { onClick: clearBomb }, "重置")
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _createElementVNode("div", {
        class: "btn",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (show(0)))
      }, "返回")
    ], 512), [
      [_vShow, showIndex.value == 1]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", null, [
        _hoisted_15,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((boomSecond).value = $event))
        }, null, 512), [
          [_vModelText, boomSecond.value]
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_16,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(password) ? (password).value = $event : password = $event))
        }, null, 512), [
          [_vModelText, _unref(password)]
        ])
      ]),
      _createElementVNode("div", {
        class: "btn",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (show(0)))
      }, "返回")
    ], 512), [
      [_vShow, showIndex.value == 2]
    ])
  ], 64))
}
}

})